import Asset from 'umg-ember-backend/components/record-explorer/for/asset';

<template><Asset @records={{@model}} @recordType='asset' /></template>
